module.exports = "/images/mpo_white_600_200.png?652e3c9b0bf7bd5e25926b83c3c2b41f";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/images/mpo_white_600_200.png
// module id = Tkkx
// module chunks = 29